"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const type_1 = require("../../../type");
const Page_Function_1 = require("../../page/utils/Page.Function");
const Field_Constant_1 = require("../utils/Field.Constant");
const Field_Icons_1 = require("../utils/Field.Icons");
const FieldSelect = ({ props }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const [open, setOpen] = React.useState(false);
    const [firstLoad, setFirstLoad] = React.useState(true);
    const id = (0, Page_Function_1.FunctionUseId)();
    React.useEffect(() => {
        if (firstLoad || props.reset) {
            props.setValue((props === null || props === void 0 ? void 0 : props.isMultiple) ? [] : { label: "", value: "" });
            setFirstLoad(false);
        }
        else {
            return;
        }
    }, [props.reset]);
    React.useEffect(() => {
        let isMounted = true;
        if (id) {
            if (window !== undefined && window !== null) {
                window.addEventListener("click", (e) => {
                    var _a, _b, _c;
                    const self = (_c = String((_b = (_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.parentNode) === null || _b === void 0 ? void 0 : _b.className)) === null || _c === void 0 ? void 0 : _c.includes(id);
                    if (!self) {
                        setOpen(false);
                    }
                });
            }
        }
        return () => {
            isMounted = false;
        };
    }, [id]);
    const isDisabled = typeof props.disabled === type_1.TYPE_FUNCTION
        ? props.disabled(props)
        : props.disabled;
    if (props.isMultiple) {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { id: props.name, className: `${Field_Constant_1.TEXT_AUTHOR}-input ${id} ${typeof props.classNameInput === type_1.TYPE_FUNCTION
                    ? props.classNameInput(props)
                    : props.classNameInput}`, onClick: () => {
                    if (isDisabled) {
                        return;
                    }
                    else {
                        setOpen(!open);
                    }
                } },
                React.createElement("div", { style: {
                        display: "flex",
                    }, className: `${Field_Constant_1.TEXT_AUTHOR}-values ${typeof props.classNameValues === type_1.TYPE_FUNCTION
                        ? props.classNameValues(props)
                        : props.classNameValues}` }, ((_a = props.value) === null || _a === void 0 ? void 0 : _a.length) > 0
                    ? (_b = props.value) === null || _b === void 0 ? void 0 : _b.map((item, index) => {
                        return (React.createElement("div", { className: `${Field_Constant_1.TEXT_AUTHOR}-value ${typeof props.classNameValue === type_1.TYPE_FUNCTION
                                ? props.classNameValue(props)
                                : props.classNameValue}`, onClick: () => {
                                props.value.splice(index, 1);
                            }, key: `key-index-${index}` }, item === null || item === void 0 ? void 0 : item.label));
                    })
                    : props.placeholder
                        ? props.placeholder
                        : "Select"),
                open && !isDisabled && (React.createElement("div", { className: `${Field_Constant_1.TEXT_AUTHOR}-options ${typeof props.classNameOptions === type_1.TYPE_FUNCTION
                        ? props.classNameOptions(props)
                        : props.classNameOptions}` }, (_d = (_c = props.options) === null || _c === void 0 ? void 0 : _c.filter((i) => {
                    return props.value.indexOf(i) === -1;
                })) === null || _d === void 0 ? void 0 : _d.map((option, index) => {
                    return (React.createElement("div", { onClick: () => {
                            props.setValue((prev) => {
                                let temp = [...prev];
                                temp.push(option);
                                return [...temp];
                            });
                        }, key: `key-option-${index}`, className: `${Field_Constant_1.TEXT_AUTHOR}-option ${typeof props.classNameOption === type_1.TYPE_FUNCTION
                            ? props.classNameOption(props)
                            : props.classNameOption}` }, option === null || option === void 0 ? void 0 : option.label));
                }))))));
    }
    else {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { id: props.name, className: `${Field_Constant_1.TEXT_AUTHOR}-input ${id} ${typeof props.classNameInput === type_1.TYPE_FUNCTION
                    ? props.classNameInput(props)
                    : props.classNameInput}`, onClick: () => {
                    if (isDisabled) {
                        return;
                    }
                    else {
                        setOpen(!open);
                    }
                } },
                React.createElement("div", { style: {
                        display: "flex",
                        justifyContent: "space-between",
                    }, className: `${Field_Constant_1.TEXT_AUTHOR}-value ${typeof props.classNameValue === type_1.TYPE_FUNCTION
                        ? props.classNameValue(props)
                        : props.classNameValue}` },
                    ((_e = props.value) === null || _e === void 0 ? void 0 : _e.value)
                        ? (_g = (_f = props === null || props === void 0 ? void 0 : props.options) === null || _f === void 0 ? void 0 : _f.find((option) => option.value === props.value.value)) === null || _g === void 0 ? void 0 : _g.label
                        : props.placeholder
                            ? props.placeholder
                            : "Select",
                    open ? (React.createElement(Field_Icons_1.ICONS_CHEVRON_UP, { onClick: (e) => {
                            e.stopPropagation();
                            if (isDisabled) {
                                return;
                            }
                            else {
                                setOpen(!open);
                            }
                        }, className: `${Field_Constant_1.TEXT_AUTHOR}-icon ${typeof props.classNameIcon === type_1.TYPE_FUNCTION
                            ? props.classNameIcon(props)
                            : props.classNameIcon}`, style: props.classNameIcon
                            ? {}
                            : {
                                height: "18px",
                                width: "18px",
                                marginTop: "auto",
                                marginBottom: "auto",
                            } })) : (React.createElement(Field_Icons_1.ICONS_CHEVRON_DOWN, { onClick: (e) => {
                            e.stopPropagation();
                            if (isDisabled) {
                                return;
                            }
                            else {
                                setOpen(!open);
                            }
                        }, className: `${Field_Constant_1.TEXT_AUTHOR}-icon ${typeof props.classNameIcon === type_1.TYPE_FUNCTION
                            ? props.classNameIcon(props)
                            : props.classNameIcon}`, style: props.classNameIcon
                            ? {}
                            : {
                                height: "18px",
                                width: "18px",
                                marginTop: "auto",
                                marginBottom: "auto",
                            } }))),
                open && !isDisabled && (React.createElement("div", { className: `${Field_Constant_1.TEXT_AUTHOR}-options ${typeof props.classNameOptions === type_1.TYPE_FUNCTION
                        ? props.classNameOptions(props)
                        : props.classNameOptions}` }, (_j = (_h = props.options) === null || _h === void 0 ? void 0 : _h.filter((i) => {
                    return i.value !== props.value.value;
                })) === null || _j === void 0 ? void 0 : _j.map((option, index) => {
                    return (React.createElement("div", { onClick: () => {
                            props.setValue(option);
                            setOpen(false);
                        }, key: `key-option-${index}`, className: `${Field_Constant_1.TEXT_AUTHOR}-option ${typeof props.classNameOption === type_1.TYPE_FUNCTION
                            ? props.classNameOption(props)
                            : props.classNameOption}` }, option === null || option === void 0 ? void 0 : option.label));
                }))))));
    }
};
exports.default = FieldSelect;
